export default __webpack_public_path__ + "static/media/bee-mobile.c7f5522b.png";